import { NgxToastrService } from './../services/utils/ngx-toastr.service';
import { AuthService } from './../services/auth/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { API_ENDPOINT } from '../services/config/config';

@Injectable()
export class ApyKeyInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private ngxToastrService: NgxToastrService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
      const secretApiKey: string = "c58aaa5a-a026-4fe8-8ef3-1bcec32e2bd9";

      let request = req;

      if (!req.headers.has('skipApiKeyInterceptor')) {
        request = req.clone({
          setHeaders: {
            ApiKey: secretApiKey,
          },
        });
      }

      // if (secretApiKey) {
      //   request = req.clone({
      //     setHeaders: {
      //       ApiKey: secretApiKey,
      //     },
      //   });
      // }


      return next.handle(request).pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status === 401) {
            // this.ngxToastrService.error('No autorizado');
            // this.authService.logout();
          } else if (err.status === 403) {
            // this.ngxToastrService.error('Usuario sin permisos');
            // this.authService.logout();
          }

          return throwError(err);
        })
      );
  }
}
